import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { IAllMaterialsResponse, IMaterial } from "../models/Material";

export default function useMaterials() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const materials = useQuery({
    queryKey: ["materials"],
    queryFn: () => get<IAllMaterialsResponse>("/material"),
    staleTime: 1000 * 60 * 5,
  });

  const create = useMutation(
    (material: Partial<IMaterial>) => post("/material", material),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["materials"]);
      },
    }
  );

  const update = useMutation(
    (material: IMaterial) => put(`/material/${material.id}`, material),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["materials"]);
      },
    }
  );

  const remove = useMutation(
    (materialId: string) => del(`/material/${materialId}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["materials"]);
      },
    }
  );

  return {
    materials,
    create,
    update,
    remove,
  };
}
